import { useEffect, useRef } from 'react';

type ParallaxBlobProps = {
  className?: string;
  from: string; // tailwind color class e.g. 'from-indigo-200'
  to: string; // tailwind color class e.g. 'to-blue-200'
  width?: string; // tailwind w- classes or arbitrary width like 'w-80'
  height?: string; // tailwind h- classes like 'h-80'
  speed?: number; // multiplier for scroll speed (e.g., 0.15)
  initialTranslateY?: number; // starting translate in px
};

export default function ParallaxBlob({
  className = '',
  from,
  to,
  width = 'w-72',
  height = 'h-72',
  speed = 0.15,
  initialTranslateY = 0,
}: ParallaxBlobProps) {
  const ref = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const el = ref.current;
    if (!el) return;

    const handleScroll = () => {
      const y = window.scrollY * speed + initialTranslateY;
      el.style.transform = `translate3d(0, ${y}px, 0)`;
    };

    handleScroll();
    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, [speed, initialTranslateY]);

  return (
    <div
      ref={ref}
      aria-hidden
      className={[
        'pointer-events-none absolute rounded-full blur-3xl opacity-50',
        `bg-gradient-to-tr ${from} ${to}`,
        width,
        height,
        className,
      ].join(' ')}
    />
  );
}
